import { useReportingToolsStore } from '@/pages/reporting-tools/store/useReportingToolsStore';
import { useSuspenseQuery } from '@apollo/client';
import {
  FetchReportingToolsMissionSummaryQuery,
  FetchReportingToolsMissionSummaryQueryVariables,
  FETCH_REPORTING_TOOLS_MISSION_SUMMARY,
} from '@edwin-group/cj-graphql';
import { useState, useEffect, useDeferredValue } from 'react';

export const useMissionSummary = () => {
  const filtersStore = useReportingToolsStore((state) => state.filters);
  const filters = useDeferredValue(filtersStore);
  const isPending = filtersStore !== filters;
  const [traitExpanded, setTraitExpanded] = useState<string | null>(null);
  const [missionSelected, setMissionSelected] = useState<string | null>(null);

  const { data, error } = useSuspenseQuery<
    FetchReportingToolsMissionSummaryQuery,
    FetchReportingToolsMissionSummaryQueryVariables
  >(FETCH_REPORTING_TOOLS_MISSION_SUMMARY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      schoolDocumentIds: filters.schoolDocumentIds,
      academicYear: filters.academicYear,
      cohortDocumentIds: filters.cohortDocumentIds,
    },
    errorPolicy: 'all',
  });

  useEffect(() => {
    if (traitExpanded) {
      const mission = data?.fetchReportingToolsMissionSummary?.missionSummary?.find(
        (summary) => summary?.header?.trait === traitExpanded,
      );
      setMissionSelected(mission?.missions?.[0]?.roleModel || null);
    }
  }, [data, traitExpanded]);

  return {
    data,
    error,
    traitExpanded,
    missionSelected,
    setTraitExpanded,
    setMissionSelected,
    isPending,
  };
};
